import React from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import Loader from '../../../../components/Loader/Loader'
import WhyHostFormBlock2 from '../../../../components/siteadmin/WhyHostPageSettings/WhyHostFormBlock2/WhyHostFormBlock2'
import getWhyHostPageSettings from './getWhyHostPageSettings.graphql';
import { withQuery } from '../../../../hoc/withGraphql';

class WhyHostBlock2 extends React.Component {

    static defaultProps = {
        data: {
            loading: false
        }
    };

    render() {
        const { data: { loading, getWhyHostPage } } = this.props
        let settingsCollection = {}
        if(loading){
            return <Loader type={"text"} />;
        } else {
            getWhyHostPage.map((item, key) => {
                settingsCollection[item.name] = item.value
            });
            return <WhyHostFormBlock2 initialValues={settingsCollection} />
        }
    }
}

export default compose(
    injectIntl,
    withQuery(getWhyHostPageSettings, {
        options: {
            fetchPolicy: 'network-only',
            ssr: false
        }
    }),
)(WhyHostBlock2);